import * as React from 'react';

import { ModernSticky, OldSticky, SimpleSticky } from './components';
import { EStickyType } from './constants';
import { useStickyProps } from './useStickyProps';

export interface IStickyProps {
  onTopStuck?: (isIntersecting: boolean) => void;
  onBottomStuck?: (isIntersecting: boolean) => void;
  topOffset?: number | string;
  bottomOffset?: number | string;
  zIndex?: number;
  testId?: string;
}

/**
 * Компонент-прилипалка с возможностью отслеживать события прилипания,
 * основанный на IntersectionObserver для современных браузеров
 * и на событиях scroll-resize для старых браузеров.
 * Предполагается, что parent имеет position: relative
 */
export const Sticky: React.FC<React.PropsWithChildren<IStickyProps>> = props => {
  const { children, zIndex, onBottomStuck, onTopStuck, topOffset, bottomOffset, testId } = props;
  const { bottom, top, stickyType } = useStickyProps({
    onBottomStuck,
    onTopStuck,
    topOffset,
    bottomOffset,
  });

  switch (stickyType) {
    case EStickyType.Simple:
      return (
        <SimpleSticky testId={testId} zIndex={zIndex} bottom={bottom} top={top}>
          {children}
        </SimpleSticky>
      );
    case EStickyType.Modern:
      return (
        <ModernSticky
          testId={testId}
          onBottomStuck={onBottomStuck}
          onTopStuck={onTopStuck}
          zIndex={zIndex}
          bottom={bottom}
          top={top}
        >
          {children}
        </ModernSticky>
      );
    case EStickyType.Old:
      return (
        <OldSticky
          testId={testId}
          onBottomStuck={onBottomStuck}
          onTopStuck={onTopStuck}
          zIndex={zIndex}
          bottom={bottom}
          top={top}
        >
          {children}
        </OldSticky>
      );
  }
};

Sticky.displayName = 'Sticky';
